import { Description } from '@mui/icons-material';

export const PATENT_SEARCH_ROUTES = {
  BASE: '/dashboard/patent-search',
} as const;

export const USPTO_API_CONFIG = {
  BASE_URL: 'https://api.uspto.gov/api/v1/patent/applications',
  DEFAULT_PAGE_SIZE: 25,
  STALE_TIME: 5 * 60 * 1000,
  CACHE_TIME: 10 * 60 * 1000,
} as const;

export const PATENT_SEARCH_FIELDS = [
  'applicationNumberText',
  'applicationMetaData.inventionTitle',
  'applicationMetaData.filingDate',
  'applicationMetaData.patentNumber',
  'applicationMetaData.grantDate',
  'applicationMetaData.applicationTypeLabelName',
  'applicationMetaData.applicationStatusDescriptionText',
  'applicationMetaData.firstApplicantName',
  'applicationMetaData.inventorBag',
  'applicationMetaData.applicationStatusDate',
] as const;

export const PATENT_SORT_OPTIONS = [
  { label: 'Filing Date (Newest)', value: 'filingDate_desc' },
  { label: 'Filing Date (Oldest)', value: 'filingDate_asc' },
  { label: 'Grant Date (Newest)', value: 'grantDate_desc' },
  { label: 'Grant Date (Oldest)', value: 'grantDate_asc' },
] as const;

export const PATENT_STATUS_OPTIONS = [
  { label: 'Any Status', value: '' },
  { label: 'Patented Case', value: 'Patented Case' },
  { label: 'Patent Pending', value: 'Patent Pending' },
  { label: 'Abandoned', value: 'Abandoned' },
  { label: 'Published', value: 'Published' },
] as const;

export const PATENT_TYPE_OPTIONS = [
  { label: 'Any Type', value: '' },
  { label: 'Utility', value: 'Utility' },
  { label: 'Design', value: 'Design' },
  { label: 'Plant', value: 'Plant' },
  { label: 'Reissue', value: 'Reissue' },
  { label: 'Provisional', value: 'Provisional' },
  { label: 'PCT', value: 'PCT' },
] as const;

export const SORT_FIELD_MAP: Record<
  string,
  { field: string; order: 'asc' | 'desc' }
> = {
  filingDate_desc: { field: 'applicationMetaData.filingDate', order: 'desc' },
  filingDate_asc: { field: 'applicationMetaData.filingDate', order: 'asc' },
  grantDate_desc: { field: 'applicationMetaData.grantDate', order: 'desc' },
  grantDate_asc: { field: 'applicationMetaData.grantDate', order: 'asc' },
};

export const TAB_ICONS: Record<string, React.ReactElement> = {
  Patents: <Description fontSize="large" />,
};

export const ALL_TABS = [
  {
    label: 'Patents',
    path: PATENT_SEARCH_ROUTES.BASE,
    isEnabled: true,
  },
];

export const DIRECTION_OPTIONS = [
  { value: '', display: 'All Directions' },
  { value: 'INCOMING', display: 'Incoming' },
  { value: 'OUTGOING', display: 'Outgoing' },
  { value: 'INTERNAL', display: 'Internal' },
];
